<template>
    <Input :placeholder="$t('Packaging text')" id="packagingText" classes="col-12 stand-packaging" name="packagingText" rules="required"
        :value="product.attributes.packagingText" @updated-value="updatedInputField" :label="label" />
</template>
<script>
import { mapGetters } from "vuex";
import Input from "../../../partials/input/Input";
import useProduct from "../../useProduct";

export default {
    components: {
        Input
    },
    props: {
        type: {
            type: String,
        },
        label: {
            type: String,
        },
    },
    computed: {
        ...mapGetters({
            product: 'product/getProduct',
        })
    },
    setup() {
        const {
            updatedInputField,
        } = useProduct()

        return {
            updatedInputField,
        }
    }
}
</script>